import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.handleGlobalKeydown = this.handleGlobalKeydown.bind(this)
    document.addEventListener("keydown", this.handleGlobalKeydown)
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleGlobalKeydown)
  }

  handleGlobalKeydown(event) {
    if (event.key === "n" && !this.isInputFocused()) {
      event.preventDefault()
      this.inputTarget.focus()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.inputTarget.value = ""
      this.inputTarget.blur()
    }
  }

  handleSubmitEnd(event) {
    if (event.detail.success) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
    }
  }

  isInputFocused() {
    const active = document.activeElement
    const tag = active?.tagName?.toLowerCase()
    return tag === "input" || tag === "textarea" || active?.isContentEditable
  }
}
